import React from 'react';

import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * for this page
 */

class Gotop extends React.PureComponent {
    gotop() {
        window.scroll(0, 0);
    }

    render() {
        return <div className={styles.Gotop} onClick={this.gotop} />;
    }
}

export default errorBoundary(Gotop);
